export const USER_CATEGORY_STORE = 'USER_CATEGORY_STORE';
export const USER_CATEGORY_UPDATE = 'USER_CATEGORY_UPDATE';
export const USER_CATEGORY_DESTROY = 'USER_CATEGORY_DESTROY';
